<div class="register-number-outer-container">
  <div class="info-container">
    <div class="headings-container">
      <div>
        <adp-image imageKey="Global_Additional_Device_Onboarding_Image"></adp-image>
      </div>
      <div class="heading">
        <adp-label labelKey="RegisterCellularDevice_Additonal_Device_Questionnaire_Header"></adp-label>
      </div>
      <div class="subheading">
        <adp-label labelKey="RegisterCellularDevice_Additonal_Device_Questionnaire_Subheader"></adp-label>
      </div>
    </div>
    <div modal-body class="input-container">
      <!--<form [formGroup]="additionalDeviceQuestionnaireForm" name="additionalDeviceQuestionnaireFormGroup" class="enter-phonenumber-form">
        <div class="row">
          <div>
            <mat-radio-group class="radio-group radio-group-container" sf-aria-label="Global_SelectOption_Aria_Label" formControlName="selectedAnswer">
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="YES"><adp-label labelKey="RegisterDiagnosticDevice_Imei_Questionnaire_Answer_Yes"></adp-label></mat-radio-button>
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="NO"><adp-label labelKey="RegisterDiagnosticDevice_Imei_Questionnaire_Answer_No"></adp-label></mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row">
          <div style="margin-bottom:40px;margin-top:20px;"><button class="register-phone-button" mat-flat-button color="accent"
              (click)="handleNextEvent()" [disabled]="!additionalDeviceQuestionnaireForm.valid"><adp-label
                labelKey="Global_Button_Next"></adp-label></button>
          </div>
        </div>
      </form>-->
      <div modal-footer style="margin-bottom:30px;" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="24px" fxLayoutGap.lt-sm="12px" class="mt-3 button-container">
        <div class="mobile-button-container" style="display:flex;width:100%;gap:20px;">
        <button mat-stroked-button style="white-space:nowrap;border-radius: 6px !important;height:44px;" color="accent" (click)="goHome()"><adp-label labelKey="Global_Button_Dashboard"></adp-label></button>
        <button mat-flat-button style="white-space:nowrap;border-radius: 6px !important;height:44px;" color="accent" (click)="addAnotherDevice()"><adp-label labelKey="Global_Button_Additional_Device"></adp-label></button>
      </div>
      </div>
    </div>
  </div>
</div>
